import { Injectable } from '@angular/core'
import { FeathersService } from '../feathers.service'
import { Observable, from } from 'rxjs'
import { catchError, map } from 'rxjs/operators'

export interface ActiveAllocationManagerPayload {
  socialServiceId: number
  locationId: number
}

export interface ActiveAllocationCurrentUser {
  allocationId: number
  socialServiceId: number
  locationId: number
  handle?: string
}

@Injectable({
  providedIn: 'root',
})
export class ActiveAllocationManagerService {
  private readonly service = 'features/active-allocation-manager'

  constructor(private feathersService: FeathersService) {}

  set(socialServiceId: number, locationId: number): Observable<any> {
    const payload: ActiveAllocationManagerPayload = { socialServiceId, locationId }
    const service = this.feathersService.service(this.service)
    return from(service.create(payload)).pipe(
      map((response: any) => response),
      catchError((error) => {
        console.error('Error in ActiveAllocationManagerService:', error)
        throw error
      }),
    )
  }

  get(): Observable<ActiveAllocationCurrentUser[]> {
    const service = this.feathersService.service(this.service)
    return from(service.find()).pipe(
      map((response: any) => {
        console.log('Service response:', response)
        return response.data || response
      }),
      catchError((error) => {
        console.error('Error in ActiveAllocationManagerService (get):', error)
        throw error
      }),
    )
  }
}
